module.exports = {"id":"222660","name":"Hwang Hyun Soo","rating":"71","photo":"./data/images/photos/2/222660.png","club":{"name":"FC Séoul","logo":"./data/images/clubs/FCSeoul.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HwangHyunSoo0.json
// module id = 1760
// module chunks = 0